import { render, staticRenderFns } from "./FenceAccessoriesSettings.vue?vue&type=template&id=32bcf72a&scoped=true"
import script from "./FenceAccessoriesSettings.vue?vue&type=script&lang=js"
export * from "./FenceAccessoriesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bcf72a",
  null
  
)

export default component.exports